/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputCriteriaCurrencyComponent} from './input-criteria-currency.component';
import {SelectDropdownModule} from '../shared/select-dropdown/select-dropdown.module';
import {InputModule} from '../../../input/input.module';

@NgModule({
    declarations: [
        InputCriteriaCurrencyComponent
    ],
    exports: [
        InputCriteriaCurrencyComponent
    ],
    imports: [
        CommonModule,
        SelectDropdownModule,
        InputModule
    ]
})
export class InputCriteriaCurrencyModule {
}
